import { render, staticRenderFns } from "./TrackingManagement.vue?vue&type=template&id=210e8f72&"
import script from "./TrackingManagement.vue?vue&type=script&lang=js&"
export * from "./TrackingManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports